export class FYearModel{
    DbName: string
}